module.exports = __webpack_public_path__ + "img/2011_L.5cab7229.png";